import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from './../AuthContext';
import { site_url, site_url_img } from "./../config.js";
import { parseWalletAmount } from "./../parseWalletAmount.js";
import { useNavigate } from "react-router-dom";

export default function Index() {
  const { fulluser, setfullUser, setUser } = useContext(AuthContext);
  const [open, setOpen] = useState(false);
  const [purchess, setpurchess] = useState(false);
  const [bonues, setbonues] = useState(false);
  const navigate = useNavigate();


  const handleLogout = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('mpin');
    sessionStorage.setItem("mpin_verified", "false");
    setfullUser(null);
    setUser(null);
    navigate("/Main");

  };
  const shareReferralLink = () => {
    const referralLink = `https://play.google.com/store/games?hl=en_IN`;

    const isInReactNativeWebView = typeof window.ReactNativeWebView !== 'undefined';

    if (navigator.share && !isInReactNativeWebView) {
      navigator
        .share({
          title: 'Join with my referral link!',
          text: 'Sign up now and get a bonus!',
          url: referralLink,
        })
        .then(() => console.log('Shared successfully'))
        .catch((error) => console.error('Sharing failed', error));
    } else if (isInReactNativeWebView) {
      // Send referralLink to React Native
      window.ReactNativeWebView.postMessage(JSON.stringify({
        type: 'SHARE_REFERRAL',
        url: referralLink,
      }));
    } else {
      alert('Your device does not support native sharing.');
    }
  };
  useEffect(() => {

  }, [fulluser]);
  return (
    <><div className="appHeader bg-primary text-light">
      <div className="left">
        <a
          href="#"
          className="headerButton"
          data-bs-toggle="modal"
          data-bs-target="#sidebarPanel"
        >
          <ion-icon name="menu-outline" />
        </a>
      </div>
      <div className="pageTitle">
        <h4 style={{ color: 'white', fontWeight: '700', fontSize: '18px' }}>APM</h4>
      </div>
      <div className="right">
        <Link to="#" className="headerButton">
          <ion-icon className="icon" name="notifications-outline" />
          <span className="badge badge-danger">4</span>
        </Link>

      </div>
    </div>
      <div
        className="modal fade panelbox panelbox-left"
        id="sidebarPanel"
        tabIndex={-1}
        role="dialog"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-body p-0">
              {fulluser && fulluser.username != '' && (
                <div className="profileBox pt-2 pb-2">
                  <div className="image-wrapper">

                    <img
                      src={'./man.png'}
                      alt="image"
                      className="imaged  w36"
                    />

                  </div>
                  {fulluser && fulluser.username != '' && (
                    <div className="in">

                      <strong>{fulluser.username}</strong>
                      <div className="text-muted">ID: {fulluser.phone}</div>

                    </div>
                  )}
                  <a
                    href="#"
                    className="btn btn-link btn-icon sidebar-close"
                    data-bs-dismiss="modal"
                  >
                    <ion-icon name="close-outline" />
                  </a>
                </div>
              )}

              <div className="listview-title mt-1">Menu</div>
              <ul className="listview flush transparent no-line image-listview">


                {fulluser && fulluser.username != '' && (
                  <>
                    <li>
                      <Link to={`/Settings`} className="item">
                        <div className="icon-box bg-primary">
                          <ion-icon name="person-outline"></ion-icon>
                        </div>
                        <div className="in">Profile</div>
                      </Link>
                    </li>



                    <li>
                      <Link to={`/Orderhistroy`} className="item">
                        <div className="icon-box bg-primary">
                          <ion-icon name="card-outline" />
                        </div>
                        <div className="in">Order History</div>
                      </Link>
                    </li>
                    <li>
                      <Link to={`/CustomerReport`} className="item">
                        <div className="icon-box bg-success">
                          <ion-icon name="bar-chart-outline"></ion-icon>
                        </div>
                        <div className="in">Report</div>
                      </Link>
                    </li>
                    <li>
                      <a className="item" onClick={() => setpurchess(!purchess)}>
                        <div className="item22  align-items-center" style={{ cursor: "pointer" }}>
                          <div className="icon-box bg-primary">
                            <ion-icon name="cart-outline"></ion-icon>
                          </div>
                          <div className="in">Purchase Details</div>
                        </div>
                      </a>

                    </li>
                    {purchess && (
                      <ul className="ps-4 dropul" >
                        <li className='droplist'><Link to={'/Purchasedetails'} className="droplista"><ion-icon name="arrow-forward-outline"></ion-icon> Purchase History</Link></li>
                        <li className='droplist'><Link to={'/Yearlypurchese'} className="droplista" ><ion-icon name="arrow-forward-outline"></ion-icon> Yearly Purchase Details</Link></li>
                        <li className='droplist'><Link to={'/Monthlypurchess'} className="droplista"><ion-icon name="arrow-forward-outline"></ion-icon> Monthly Purchase Details</Link></li>
                        <li className='droplist'><Link to={'/Taxbills'} className="droplista" ><ion-icon name="arrow-forward-outline"></ion-icon> Total Tax Paid</Link></li>
                      </ul>
                    )}
                    
                  </>
                )}





              


              </ul>

              <ul className="listview flush transparent no-line image-listview">

                {fulluser && fulluser.username != '' && (
                  <>
                    
                    <li>
                      <Link to={`/Suspendedbonus`} className="item">
                        <div className="icon-box bg-danger">
                          <ion-icon name="alert-circle-outline"></ion-icon>
                        </div>
                        <div className="in">
                          <div>Overflow Account</div>
                          <span className="badge badge-danger">🪙 {parseWalletAmount(fulluser?.overflow_balance ?? fulluser?.suspended_bonus).toFixed(2)}</span>
                        </div>
                      </Link>
                    </li>
                    {/*                  <li>
                 <Link to={`/Mpin`} className="item">
                   <div className="icon-box bg-primary">
                   <ion-icon name="lock-closed-outline"></ion-icon>
                   </div>
                   <div className="in">M-PIN</div>
                 </Link>
               </li> */}
                  </>
                )}




                {fulluser?.username == null && (
                  <li>
                    <Link to={`/Signin`} className="item">
                      <div className="icon-box bg-primary">
                        <ion-icon name="person-add-outline"></ion-icon>
                      </div>
                      <div className="in">Login/Registration</div>
                    </Link>
                  </li>
                )}


                <li>
                  <a to={`/Settings`} className="item">
                    <div className="icon-box bg-primary">
                      <ion-icon name="notifications-outline"></ion-icon>
                    </div>
                    <div className="in">Push Notification</div>
                  </a>
                </li>
                <li>
                  <Link to={`/SupportForm`} className="item">
                    <div className="icon-box bg-primary">
                      <ion-icon name="chatbubble-outline" />
                    </div>
                    <div className="in">Support</div>
                  </Link>
                </li>
                



                <li>
                  <Link to={`/About`} className="item">
                    <div className="icon-box bg-primary">
                      <ion-icon name="information-circle-outline"></ion-icon>
                    </div>
                    <div className="in">About Us</div>
                  </Link>
                </li>

                <li>
                  <Link to={`/Privacy`} className="item">
                    <div className="icon-box bg-primary">
                      <ion-icon name="settings-outline" />
                    </div>
                    <div className="in">Privacy Policy</div>
                  </Link>
                </li>
                <li>
                  <Link to={`/Terms`} className="item">
                    <div className="icon-box bg-primary">
                      <ion-icon name="settings-outline" />
                    </div>
                    <div className="in">Terms and Conditions</div>
                  </Link>
                </li>
                <li>
                  <Link to={`/Refund`} className="item">
                    <div className="icon-box bg-primary">
                      <ion-icon name="settings-outline" />
                    </div>
                    <div className="in">Refund Policy</div>
                  </Link>
                </li>
                <li>
                  <Link to="/CancellationPolicy" className="item">
                    <div className="icon-box bg-warning">
                      <ion-icon name="close-circle-outline" />
                    </div>
                    <div className="in">Cancellation Policy</div>
                  </Link>
                </li>

                <li>
                  <Link to="/ContactUs" className="item">
                    <div className="icon-box bg-success">
                      <ion-icon name="call-outline" />
                    </div>
                    <div className="in">Contact Us</div>
                  </Link>
                </li>
                {/* <li>
                  <a onClick={shareReferralLink} className="item">
                    <div className="icon-box bg-primary">
                      <ion-icon name="share-social-outline"></ion-icon>
                    </div>
                    <div className="in">Share App</div>
                  </a>
                </li> */}
                {fulluser && fulluser.username != '' && (
                  <li>
                    <a onClick={handleLogout} to="#" className="item">
                      <div className="icon-box bg-primary">
                        <ion-icon name="log-out-outline"></ion-icon>
                      </div>
                      <div className="in">Log out</div>
                    </a>
                  </li>
                )}
              </ul>
              {/* * others */}
              {/* send money */}


            </div>
          </div>
        </div>
      </div>
    </>
  )
}
